import moment from "moment";

import { CertificateStatusType } from "./certificateStatus";

const today = moment();

const calcStatus = (momentDate, bufferZone) => {
  if (momentDate.diff(today) < 0) {
    return CertificateStatusType.EXPIRED;
  }
  if (bufferZone && momentDate.diff(today, "months") < bufferZone) {
    return CertificateStatusType.BUFFER;
  }

  return CertificateStatusType.OK;
};

const certificateStatus = (certificate) => {
  let validUntil = null;

  if (certificate.validPeriod) {
    validUntil = moment(certificate.validPeriod);
  } else if (certificate.defaultValidPeriod) {
    validUntil = moment(certificate.completedDate).add(certificate.defaultValidPeriod, "months").endOf("month");
  }

  let certificateStatus = certificate.defaultValidPeriod
    ? calcStatus(validUntil, certificate.bufferZone)
    : CertificateStatusType.OK;

  return {
    ...certificate,
    status: certificateStatus,
    validUntil: validUntil?.valueOf(),
    approveStatus: certificate.approveStatus || certificate.status || null,
  };
};

const CertificateService = {
  map(userCertificates) {
    return {
      certificates: userCertificates.certificates.map(certificateStatus),
      customCertificates: userCertificates.customCertificates.map(certificateStatus),
    };
  },
};

export default CertificateService;
